export default __webpack_public_path__ + "static/media/ticketmaster.c5f3db81.png";